/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeCancelCategory } from './exchange-cancel-category';
// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeManagementUser } from './exchange-management-user';
// May contain unused imports in some cases
// @ts-ignore
import type { ExposeBankAccount } from './expose-bank-account';

/**
 * 
 * @export
 * @interface AdminPatchStatusDataDto
 */
export interface AdminPatchStatusDataDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof AdminPatchStatusDataDto
     */
    'exchangeUuid': string;
    /**
     * 환급 신청 금액
     * @type {number}
     * @memberof AdminPatchStatusDataDto
     */
    'amountRequested': number;
    /**
     * 환급 신청 전 환급 가능 금액
     * @type {number}
     * @memberof AdminPatchStatusDataDto
     */
    'exchangeableAmountBeforeRequest': number;
    /**
     * 환급 예정 금액
     * @type {number}
     * @memberof AdminPatchStatusDataDto
     */
    'amountBeExchanged': number;
    /**
     * 세금
     * @type {number}
     * @memberof AdminPatchStatusDataDto
     */
    'tax': number;
    /**
     * 환급 상태
     * @type {string}
     * @memberof AdminPatchStatusDataDto
     */
    'status': AdminPatchStatusDataDtoStatusEnum;
    /**
     * 생성 일시
     * @type {string}
     * @memberof AdminPatchStatusDataDto
     */
    'createdAt': string;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof AdminPatchStatusDataDto
     */
    'exchangeCancelOtherReason': string;
    /**
     * 환급 (예정) 일시
     * @type {string}
     * @memberof AdminPatchStatusDataDto
     */
    'exchangeAt': string;
    /**
     * 취소 여부
     * @type {boolean}
     * @memberof AdminPatchStatusDataDto
     */
    'isCancelled': boolean;
    /**
     * 환급 불가 사유
     * @type {ExchangeCancelCategory}
     * @memberof AdminPatchStatusDataDto
     */
    'exchangeCancelCategory': ExchangeCancelCategory;
    /**
     * 노출용 계좌 정보
     * @type {ExposeBankAccount}
     * @memberof AdminPatchStatusDataDto
     */
    'exposeBankAccount': ExposeBankAccount;
    /**
     * 노출용 환급 관리되는 유저
     * @type {ExchangeManagementUser}
     * @memberof AdminPatchStatusDataDto
     */
    'exchangeManagementUser': ExchangeManagementUser;
}

export const AdminPatchStatusDataDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type AdminPatchStatusDataDtoStatusEnum = typeof AdminPatchStatusDataDtoStatusEnum[keyof typeof AdminPatchStatusDataDtoStatusEnum];


